export class NativeStreamMapKeyType {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamScalarOutputKind",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamMapKeyType.attributeTypeMap;
    }
    constructor() {
    }
}
